import React, { useEffect } from 'react';
import { Sidebarf } from './Utils';


export default function Navbar() {
  
  return (
 <div>
 <div className="muzi-navbar">
 <nav role='navigation'>
  <div className='nav-upper'>
  <div className='nav-inner'>
    <div className="nav-brand">
       <a href="">
        <img src="https://i.ibb.co/k2Frnqr/Picsart-23-12-18-14-18-05-855.png" alt="" srcset="" />
        </a>
    </div>
    <div className="open-muzi-menu" onClick={Sidebarf()}>
      <a href="javascript:void(0)"><i class="fa fa-bars" aria-hidden="true"></i></a>
    </div>
    <div className="nav-menu">
  <ul>
    <li><a href="#">Services</a>
      <ul>
      <li><a href="#contactus">Web Developement</a></li>
        <li><a href="#contactus">E-Commerce Developement</a></li>
        <li><a href="#contactus">CMS - Wordpress, Shopify</a></li>
        <li><a href="#contactus">Frontend Developement</a></li>
        <li><a href="#contactus">UI/UX</a></li>
        <li><a href="#contactus">Digital Marketing</a></li>
        <li><a href="#contactus">University Projects / Assignments</a></li>
      </ul>
    </li>
    <li><a href="#introduction">Company</a>
    <ul>
        <li><a href="#introduction">What we do</a></li>
      </ul>
    </li>
    <li><a href="#contactus">Hire a Pro</a></li>
    <li><a href="#contactus">Contact</a></li>
  </ul>
  </div>
  </div>
  </div>
</nav>  
 </div>




<div className="muzi-navbar-mobile">
  <div className="muzi-mobile-inner">

<div className="close-muzi-nav" onClick={Sidebarf()}>
  <a href="javascript:void(0)">
  <i class="fa fa-times" aria-hidden="true"></i>
  </a>
</div>

  <ul>
    <li><a href="#">Services</a>
      <ul>
        <li><a href="#contactus">Web Developement</a></li>
        <li><a href="#contactus">E-Commerce Developement</a></li>
        <li><a href="#contactus">CMS - Wordpress, Shopify</a></li>
        <li><a href="#contactus">Frontend Developement</a></li>
        <li><a href="#contactus">UI/UX</a></li>
        <li><a href="#contactus">Digital Marketing</a></li>
        <li><a href="#contactus">University Projects / Assignments</a></li>
      </ul>
    </li>
    <li><a href="#introduction">Company</a>
    <ul>
        <li><a href="#introduction">What we do</a></li>
       
      </ul>
    </li>
    <li><a href="#contactus">Hire a Pro</a></li>
    <li><a href="#contactus">Contact</a></li>
  </ul>
  </div>
</div>



 </div>

  );
}
